import React from 'react';

class AvisoMapasDeCobertura_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Aviso Mapas de Cobertura';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_AVISO_MAPAS_COBERTURA_2024_V1.pdf?alt=media&token=503da598-a5ea-4d23-a986-bc5abacd4eec';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default AvisoMapasDeCobertura_pdf